import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FavoriteGood } from 'components/Profile/Favorite/Item';
import Cookies from 'js-cookie';


import type { BasketItem } from 'global/api/modules/user/user';
import type { IGood, IGoodCard, IGoodCompare, IOneClickGood, IGoodInCart } from 'entities/products/model/IGood';


export interface IGoodsState {
  favoriteIds: number[];
  compareIds: number[];
  cartSize: number;
  cartError: boolean;
  cartGood?: IGoodCard | FavoriteGood | IGood | IGoodCompare | null;
  oneClickGood?: IOneClickGood | null
  activeMobCatalog: boolean;
  basketItems: BasketItem[];
  goodsInCart: IGoodInCart[];
}

const initialState: IGoodsState = {
  favoriteIds: [],
  compareIds: [],
  basketItems: [],
  cartSize: 0,
  cartError: false,
  activeMobCatalog: false,
  goodsInCart: [],

};

export const goodsSlice = createSlice({
  name: 'goods',
  initialState,
  reducers: {
    /** Устанавливает новый список избранных товаров */
    setFavorites: (state, action: PayloadAction<number[]>) => {
      state.favoriteIds = action.payload;
    },
    /** Устанавливает общую информацию о товарах в корзине */
    setBasketItems: (state, action: PayloadAction<BasketItem[]>) => {
      state.basketItems = action.payload
    },
    /** Устанавливает полную информацию о товарах в корзине */
    setGoodsInCart: (state, action: PayloadAction<IGoodInCart[]>) => {
      state.goodsInCart = action.payload
      state.cartSize = action.payload.reduce((acc, item) => item.isRemoved ? acc : acc + item.quantity, 0);
    },

    /** Добавляет новый элемент список избранных товаров */
    addFavorite: (state, action: PayloadAction<number>) => {
      state.favoriteIds = [...state.favoriteIds, action.payload];
    },
    /** Удаляет элемент из списка избранных товаров */
    removeFavorite: (state, action: PayloadAction<number>) => {
      state.favoriteIds = state.favoriteIds.filter((id) => id !== action.payload);
    },
    /** Устанавливает новый список товаров для сравнения */
    setCompare: (state, action: PayloadAction<number[]>) => {
      Cookies.set('compareIds', action.payload.toString());

      state.compareIds = action.payload;
    },
    /** Добавляет новый элемент в список товаров для сравнения */
    addCompare: (state, action: PayloadAction<number>) => {
      const cookieCompare = Cookies.get('compareIds');
      const init = cookieCompare ? cookieCompare + ',' : '';

      Cookies.set('compareIds', init + action.payload);

      const newIds = [...state.compareIds, action.payload];

      state.compareIds = newIds;
    },
    /** Удаляет элемент из списка товаров для сравнения */
    removeCompare: (state, action: PayloadAction<number>) => {
      const cookieCompare = Cookies.get('compareIds');
      if (cookieCompare) {
        const filteredCookie = cookieCompare
          .split(',')
          .map(Number)
          .filter((el) => el !== action.payload);

        Cookies.set('compareIds', filteredCookie.toString());
      }

      const newIds = state.compareIds.filter((id) => id !== action.payload);

      state.compareIds = newIds;
    },
    /** Устанавливает новое значение для количество товаров в корзине */
    setCartSize: (state, action: PayloadAction<number>) => {
      state.cartSize = action.payload;
    },
    /** Уменьшает количество товаров в корзине */
    decreesCartSize: (state, action: PayloadAction<number>) => {
      state.cartSize = state.cartSize - action.payload
    },
    /** Устанавливает флаг о наличии ошибок при работе с корзиной товаров */
    setCartError: (state, action: PayloadAction<boolean>) => {
      state.cartError = action.payload;
    },
    /** Увеличивает количество товаров в корзине на конкретное значение */
    addToCartSize: (state, action: PayloadAction<number>) => {
      state.cartSize = state.cartSize + action.payload;
    },
    /** Добавляет новый товар в корзину */
    addCartGood: (
      state,
      action: PayloadAction<{ quantity: number; good: IGoodCard | FavoriteGood | IGood | IGoodCompare }>
    ) => {
      state.cartSize = state.cartSize + action.payload.quantity;
      state.cartGood = action.payload.good;
    },
    /** Закрывает модальной окно корзины товаров */
    closeCartModal: (state) => {
      state.cartGood = null;
    },
    /** Устаналивает товар для "покупки в один клик", чем открывает соответствующее модальное окно */
    setOneClickGood: (state, action: PayloadAction<IOneClickGood>) => {
      state.oneClickGood = action.payload;
    },
    /** Закрывает модальной окно покупки товара "в один клик" */
    closeOneClickModal: (state) => {
      state.oneClickGood = null;
    },
    /** Тоггли мобильное меню */
    toogleMobCatalog: (state, action: PayloadAction<boolean>) => {
      state.activeMobCatalog = action.payload;
    },
  },
});

export const {
  setFavorites,
  addFavorite,
  removeFavorite,
  setCompare,
  addCompare,
  removeCompare,
  setCartError,
  setCartSize,
  addToCartSize,
  addCartGood,
  closeCartModal,
  setOneClickGood,
  closeOneClickModal,
  toogleMobCatalog,
  decreesCartSize,
  setBasketItems,
  setGoodsInCart,
} = goodsSlice.actions;

export default goodsSlice.reducer;
